import React from 'react';
import HideableSection from 'react-scale/corp/components/UI/HideableSection';
import { ReactJsonView } from 'react-scale/corp/components/ReactJsonView';
import { ISensorFusionSubstageInstanceLookupDto } from '@scale/sensor-fusion-shared';

import { openSelectedIfUrl } from '../helpers/url';

type SubstageInstanceTaxonomyPanelProps = {
  substageInstance: ISensorFusionSubstageInstanceLookupDto;
};

const SubstageInstanceTaxonomyPanel = ({
  substageInstance,
}: SubstageInstanceTaxonomyPanelProps) => {
  return (
    <HideableSection name="Taxonomy">
      <ReactJsonView
        src={substageInstance.taxonomy}
        name={false}
        theme="monokai"
        iconStyle="triangle"
        collapsed={1}
        onSelect={openSelectedIfUrl}
        collapseStringsAfterLength={120}
        groupArraysAfterLength={false}
        enableClipboard={true}
        displayObjectSize={false}
        displayDataTypes={false}
      />
    </HideableSection>
  );
};

export default SubstageInstanceTaxonomyPanel;
